module.exports = __webpack_public_path__ + "img/Group 27961@2x.db4ebae9.png";